import { render, staticRenderFns } from "./ArticlesChooser.vue?vue&type=template&id=3fbb0a42"
import script from "./ArticlesChooser.vue?vue&type=script&lang=js"
export * from "./ArticlesChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports